import {RsDocumentTemplate} from "../../api/dto/RsDocumentTemplate";
import {DocumentTemplateService} from "../../service/DocumentTemplateService";
import {useCallback, useState} from "react";

interface DocumentTemplateViewModelReturn {
    loading: boolean;
    documentTemplateList: RsDocumentTemplate[]
    retrieveDocumentTemplateByGroup: (groupId: string, verificationId: string) => void
}

export const DocumentTemplateViewModel = (): DocumentTemplateViewModelReturn => {

    const [documentTemplateList, setDocumentTemplateList] = useState<RsDocumentTemplate[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const retrieveDocumentTemplateByGroup = useCallback(async (groupId: string, verificationId: string) => {
        const service = DocumentTemplateService.getInstance();
        setLoading(true)
        const templates = await service.retrieveDocumentTemplateByGroup(groupId, verificationId)
        setDocumentTemplateList(templates)
        setLoading(false)
    }, [])

    return {
        loading,
        documentTemplateList,
        retrieveDocumentTemplateByGroup,
    }

}